const CATEGORIES = {
  SKINCARE: 'Skincare',
  MAKEUP: 'Makeup',
  HAIR: 'Hair',
  TECH: 'Tech & Tools',
  BODY: 'Body',
};

export default CATEGORIES;
